import type { Action, Reducer } from "redux";

import type { Record } from "~/tools/record";

export function createReducer<State>(initialState: State, reducers: Record<string, Reducer>): Reducer<State> {
	return (state: State = initialState, action: Action): State => {
		const reducer = reducers[action.type];
		return reducer ? reducer(state, action) : state;
	};
}
